<button
  mat-icon-button
  type="button"
  [attr.aria-label]="'Copier l\'adresse dans le presse-papier'"
  [matTooltip]="'Copier l\'adresse dans le presse-papier'"
  (click)="handleClick()"
>
  <svg lucideLink></svg>
</button>
